(function(){
    'use strict'; 
    angular.module('Directives').directive('bbaAccountingCarrierDetails', bbaAccountingCarrierDetails); 
    bbaAccountingCarrierDetails.$inject = [
        '$rootScope',
        'Units',
        'AccountingSurchargeTable',
        'AccountingService'
    ]; 

    function bbaAccountingCarrierDetails(
        $rootScope,
        Units,
        AccountingSurchargeTable,
        AccountingService
    ) {
        return {
            restrict    : 'E', 
            templateUrl : '/templates/directives/components/accounting/bbaAccountingCarrierDetails.html', 
            require     : '^form',
            scope : {
                ngModel         : '=',
                shippingCost    : '=',
                packages        : '=',
                currencyType    : '=',
                carrierProfile  : '=', 
                serviceProfile  : '=',
                shippingRule    : '=', 
                form            : '=', 
                isViewMode      : '=', 
                ngDisabled      : '='   
            }, 
            link        : bbaAccountingCarrierDetailsLink  
        }

        function bbaAccountingCarrierDetailsLink($scope, $attrs, $elems){
            init(); 
            $scope.recalculate = recalculate;

            function init() {
                generateCarrierDetailsValue();
                setCurrencyType();
                setWeightUnitType();
                initializeSurchargeTable();
            }

            function generateCarrierDetailsValue() {
                const chargeableWeight = angular.calculateChargeableWeight($scope.packages);
                const exTaxTotal = angular.calculateExTaxTotal($scope.shippingCost.sellPrice, $scope.shippingCost.fuelLevyTotal, $scope.shippingCost.surchargeTotal); 
                const tax = angular.calculateTax(exTaxTotal, $scope.shippingCost.taxPercent); 
                const includingTaxTotal = angular.calculateIncludingTaxTotal(exTaxTotal, tax);
                
                if($scope.ngModel === null) {
                    $scope.ngModel = {
                        chargeableWeight: chargeableWeight,
                        exTaxCharge: $scope.shippingCost.sellPrice.toFixed(2),
                        fuel: $scope.shippingCost.fuelLevyTotal.toFixed(2),
                        exTaxTotal: Number(exTaxTotal).toFixed(2),
                        tax: tax,
                        includingTaxTotal: includingTaxTotal,
                        weightUnit: $rootScope.GlobalProfile.office.weightUnit,
                        surcharges: $scope.shippingCost.surchargeDetails,

                        actualMargin: "0.00",
                        actualMarginPercentage: "0.00",            
                        additionalCharges: "0.00",
                    };
                }
            }

            function setCurrencyType(){
                $scope.currency = $scope.currencyType ? $scope.currencyType : $rootScope.GlobalProfile.office.currency;
            }

            function setWeightUnitType(){
                $scope.weightUnit = Units.weightUnit.find(unit => unit.value === $scope.ngModel.weightUnit).short.toUpperCase();
            }

            function initializeSurchargeTable(){
                const surchangeTableData = {
                    form: $scope.form,
                    surchargesData: angular.isArray($scope.ngModel.surcharges) ? $scope.ngModel.surcharges.map(item => {
                        return {
                            value: item.fix, 
                            description: item.name
                        }
                    }) : AccountingService.Invoices.convertSurchargesFieldToArray($scope.ngModel.surcharges),
                    currency: $scope.currency
                }

                $scope.accountingSurchargeTable = new AccountingSurchargeTable(surchangeTableData, updateSurchargesData, $scope.isViewMode);
                $scope.accountingSurchargeTableData = $scope.accountingSurchargeTable.tableData;
            }

            function recalculate(){  
                const runningTotal = Number($scope.ngModel.exTaxCharge) + Number($scope.ngModel.fuel);
                const exTaxTotal = $scope.accountingSurchargeTable.getSurchargesTotal(runningTotal);

                const tax = angular.calculateTax(exTaxTotal, $scope.shippingCost.taxPercent);
                const includingTaxTotal = angular.calculateIncludingTaxTotal(exTaxTotal, tax);

                $scope.ngModel.exTaxTotal = Number.isNaN(exTaxTotal) ? 0 : exTaxTotal; 
                $scope.ngModel.tax = Number.isNaN(tax) ? 0 : tax; 
                $scope.ngModel.includingTaxTotal = Number.isNaN(includingTaxTotal) ? 0 : includingTaxTotal;
            }  

            function updateSurchargesData(){
                const surchargesData = $scope.accountingSurchargeTable.getTableSurchargesData();
                $scope.ngModel.surcharges = {};
                surchargesData.forEach(surcharge => {
                    $scope.ngModel.surcharges[surcharge.description.toLowerCase()] = Number(surcharge.valueEdit.value);
                });
            }          
        }
    }
})();



// WEBPACK FOOTER //
// ./js/directives/component/accounting/bbaAccountingCarrierDetails.js